import axios from "axios";
import authHeader from "./auth/auth-header";

const baseUrl = process.env.REACT_APP_API_URL;

const getAlldetailPreviousProgramByFilters = async (params) => {

  const data = {
    startDate: params.startDate ? params.startDate : null,
    endDate: params.endDate ? params.endDate : null,
    plant: params.company ? params.company.trim() : null,
    cement: params.cement ? params.cement.trim() : null,
    retirement: params.retirement ? params.retirement.trim() : null
  };

  const url = `${ baseUrl }/details/${params.an8}`;

  const token = await authHeader();

  return axios
    .get(url, {
      params: data,
      headers: token 
    }
    )
    .then(response => {
      return response.data;
      }
      )
};

const downloadDetailPreviousProgramXlsx = async (params, an8) => {
  const data = {
    startDate: params.startDate ? params.startDate : null,
    endDate: params.endDate ? params.endDate : null,
    plant: params.company ? params.company.trim() : null,
    cement: params.cement ? params.cement.trim() : null,
    retirament: params.retirement ? params.retirement.trim() : null,
    excel: 1
  };
  const url = `${ baseUrl }/details/excelToPdf/${an8}`;
  const token = await authHeader();

  return axios
    .get(url, {
      params: data,
      headers: token 
    },
    {
      responseType: 'blob'
    }
    )
    .then(response => {
      return response.data;
      }
      )
};

const downloadDetailPreviousProgramFdf = async(params, an8) => {
  const data = {
    startDate: params.startDate ? params.startDate : null,
    endDate: params.endDate ? params.endDate : null,
    plant: params.company ? params.company : null,
    cement: params.cement ? params.cement.trim() : null,
    retirament: params.retirement ? params.retirement.trim() : null,
    excel: 0
  };
  const url = `${ baseUrl }/details/excelToPdf/${an8}`;
  const token = await authHeader();

  return axios
    .get(url, {
      params: data,
      headers: token 
    },
    {
      responseType: 'blob'
    }
    )
    .then(response => {
      return response.data;
      }
      )
};

export default {
  getAlldetailPreviousProgramByFilters,
  downloadDetailPreviousProgramXlsx,
  downloadDetailPreviousProgramFdf
};